import {Row} from 'antd';
import classes from '../Pages.module.css';
import DataField from './DataField';
import DocumentVerificationEdit from './DocumentVerificationEdit';

const DocumentVerification = (props) => {
    return(
        !props.editMode
        ?
        props.data.map((data, index) => {
            return(
                <div key={index}>
                <p></p>
                <Row className={props.editMode ? classes['RowDEX'] : classes['RowD']}>
                    <DataField 
                        editMode={false} 
                        lg={12} 
                        md={24} 
                        options={props.ad.DOC_CODE} 
                        type="Select" 
                        name="doc code" 
                        value={data.doc_code} 
                    />
                    <DataField 
                        editMode={false} 
                        lg={12} 
                        md={24} 
                        options={props.ad.RWS} 
                        type="Select" 
                        name="verify" 
                        value={data.verify} 
                    />
                    <DataField 
                        editMode={false} 
                        lg={12} 
                        md={24} 
                        name="verify by" 
                        value={data.verify_by} 
                    />
                </Row>  
                <p></p>
            </div>
            
            );
        })
           
        :
        <>
            <p></p>
            <DocumentVerificationEdit docOptions = {props.ad.DOC_CODE} verifyOptions = {props.ad.RWS}  data = {props.data} setData = {props.setData} />
        </>
    );
}

export default DocumentVerification;